<template>
    
    <div class="nfe">
        <div class="nfe-title">
            <h1>Nota fiscal eletrônica</h1>
        </div>
        <div class="container">
            <div class="row nfe-content">
                <span>
                    <h2>Digite a chave de acesso da NF-e</h2>
                </span>
                <b-form-input v-model="text1"
                  type="text">
                </b-form-input>
                {{ text1 }}
                <span>
                    <b-button href="#">Download do XML</b-button>
                </span>
                <div class="col-md-6 nfe-item">
                    <p>
                        Indústria e Comércio de Bebidas Funada Ltda.<br>
                        Fone:(18) 2101-2100 / Fax: 2101-2121<br>
                        Presidente Prudente - SP<br>
                        <span>nfe_pp@funada.com.br</span>
                    </p>
                </div>
                <div class="col-md-6 nfe-item">
                    <p>
                        Indústria e Comércio de Bebidas Funada Ltda.<br>
                        Fone/Fax:(67) 3391-2100<br>
                        Campo Grande - MS<br>
                        <span>nfe_ms@funada.com.br</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      text1: ""
    };
  }
};
</script>

<style scoped>
.nfe {
  width: 100%;
  height: 100vh;
  background: linear-gradient(#00eeaa, #3f57ef);
  font-family: "Bambino";
  text-transform: uppercase;
}

.nfe-title h1 {
  padding: 20px;
  font-size: 14pt;
  padding-left: 6%;
  padding-top: 6%;
}

.nfe-content {
  margin-top: 230px;
}

.nfe-content span {
  width: 100%;
  text-align: center;
}

.nfe-content h2 {
  text-align: center;
  color: #fff;
  font-size: 13pt;
  padding-bottom: 30px;
  font-weight: 300;
}

.nfe-content input {
  height: 60px;
  text-align: center;
  margin-bottom: 20px;
  margin-left: 50px;
  margin-right: 50px;
}

.nfe-item {
  height: 100%;
  min-height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  margin-top: 140px;
  line-height: 20px;
}

.nfe-item span {
  font-size: 11px;
  font-weight: 500;
  margin-top: 70px;
}

.nfe-item p {
  font-size: 11px;
  font-weight: 200;
  color: #fff;
  letter-spacing: 1px;
}

.btn-secondary {
  color: #000;
  background-color: #fff;
  border-color: #6c757d;
  font-size: 12px;
  padding: 12px;
  border-radius: 10px;
}

.btn-secondary:hover {
  color: #000;
  background-color: #dddddd;
  border-color: #6c757d;
  font-size: 12px;
  padding: 12px;
  border-radius: 10px;
}

input[type="text"],
input[type="number"],
input[type="password"],
textarea {
  outline: none;
  box-shadow: none !important;
  border: 1px solid #6bb5c2 !important;
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {

  .nfe-content {
    margin-top: 50px;
  }

  .nfe {
    height: 100vh;
  }

  .nfe-item {
    margin-top: 40px;
    margin-bottom: 0;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaNfe.vue